import { Box, TableHeaderMenuIcon } from "@parspec/pixel";


export const headerIconComponent = () => {
    return (
        <Box mt={1}>
            <TableHeaderMenuIcon color="secondary" fontSize="medium" />
        </Box>
    );
};